module.exports = __webpack_public_path__ + "img/maintop.eafdda4.png";